<template>
  <!-- 不可以设置的按键 -->
  <div class="disabled" v-if="inoperableKeys.includes(kk)"></div>

  <!-- fn层设置 -->
  <template v-if="operate.fnCheck.value">
    <!-- 不可以设置的按键 -->
    <div class="action_set fn_disabled_style disabled" v-if="getCurrentDevice.fnDisableKeys.includes(kk)"></div>
    <!-- fn 层 hover -->
    <div class="action_set fn_hover" v-if="hoverKK == kk"></div>
  </template>

  <!-- 键盘已改键标记 -->
  <p class="modifier" v-if="isKeyRemapped && getCurrentDevice.deviceType == DeviceType.keyboard">{{ getMagnetTextByKeyType }}</p>

  <!-- 鼠标选中 -->
  <div class="action_set active mouse" v-if="operate.currentKey.value == kk && getCurrentDevice.deviceType == DeviceType.mouse" :class="{ mouse_is_remapped: isKeyRemapped }"></div>
  <div class="action_set active mouse" v-if="isKeyRemapped && getCurrentDevice.deviceType == DeviceType.mouse"></div>
</template>

<script lang="ts" setup>
import { setData } from '@/service/driver/data'
import { getCurrentDevice } from '@/profiles/selector'
import { hoverKK } from './select.vue'
import { operate } from '@/service/driver/operate'
import { DeviceType } from '@libs/types/enum'
import { actionSet, SetType } from '@/service/driver/action_set'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import firmware from '@/upgrade/firmware'
import { Fe87v2DeviceList } from '@/define/device_vendor'
import { DeviceManager } from '@/service/device'
const props = defineProps<{
  kk: number
}>()

const setTextType = {
  [SetType.routine]: '',
  [SetType.macro]: '',
  [SetType.dks]: 'DKS',
  [SetType.mt]: 'MT',
  [SetType.tgl]: 'TGL',
  [SetType.mpt]: 'MPT',
  [SetType.end]: 'END',
  [SetType.kme]: 'KME',
  [SetType.rs]: 'RS',
}
// 当前按键是否被设置改键
const isKeyRemapped = computed(() => {
  const kk = props.kk
  const data = setData.getActionData
  if (data == undefined) {
    return false
  }
  if (data.KeyMap[kk]) {
    return true
  }
  if (data.Macros[kk]) {
    return true
  }
  if (data.Magenet[kk]) {
    return true
  }
  if (data.KeyMapModifier[kk]) {
    return true
  }
  if (data.KeyMapFire && data.KeyMapFire[kk]) {
    return true
  }
  return false
})

const getMagnetTextByKeyType = computed(() => {
  const magnet = setData.getActionData.Magenet[props.kk]
  if (magnet) {
    return setTextType[magnet.KeyType]
  }
})

const fe87v2ThanOrEqual210 = ref(false)
onMounted(async () => {
  fe87v2ThanOrEqual210.value = await firmware.fwVersionGreaterThanOrEqual('2.1.0', [...Fe87v2DeviceList])
})
onUnmounted(() => {
  fe87v2ThanOrEqual210.value = false
})

const inoperableKeys = computed(() => {
  let keys = getCurrentDevice.value.inoperableKeys
  //2.1.0以上版本，允许esc改键
  if (Fe87v2DeviceList.includes(DeviceManager.instance.state.currentPid)) {
    if (keys.includes(0x00) && fe87v2ThanOrEqual210.value) {
      keys = keys.filter((item) => item != 0x00)
    }
  }
  return keys
})
</script>

<style lang="less">
.action_set {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: var(--radius-s);

  &.fn_disabled_style {
    border: 2px solid rgba(#f23434, 0.3);
  }

  &.fn_hover {
    background-color: var(--color-brand-1);
    opacity: 0.6;
  }

  &.active {
    border: 2px solid var(--brand-color-pure);
    box-shadow: 0 0 10px rgba(var(--brand-color-pure-rgb), 0.5);
    z-index: 2;
    pointer-events: none;
    background-color: rgba(var(--brand-color-pure-rgb), 0.1);
    transition: var(--transition-base);

    &.is_remapped {
      border: 2px solid var(--color-white);
      box-shadow: 0 0 12px rgba(var(--brand-color-pure-rgb), 0.6);
      background-color: transparent;
    }
  }
  &.mouse {
    border: 0px solid var(--brand-color-pure);
  }
}

.modifier {
  position: absolute;
  bottom: 0px;
  right: 2px;
  z-index: 3;
  color: var(--color-white);
  font-size: 10px;
  font-weight: bold;
  pointer-events: none;
}
</style>
